/* OnePod sitebrede polish: vult de live bezorgbelofte op elke pagina
   ([data-oph-bezorg] / [data-oph-bezorg-lang]); zelfde logica als op-home.js. */
(function () {
  'use strict';
  if (window.__opPolishBoot) return;
  window.__opPolishBoot = true;

  var FEEST = ['2026-12-25', '2026-12-26', '2027-01-01', '2027-03-28', '2027-03-29', '2027-04-27', '2027-05-06', '2027-05-16', '2027-05-17', '2027-12-25', '2027-12-26'];
  function isVrij(d) {
    var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    return d.getDay() === 0 || d.getDay() === 6 || FEEST.indexOf(iso) >= 0;
  }
  function bezorg() {
    var nu;
    try {
      nu = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
      if (isNaN(nu)) nu = new Date();
    } catch (e) { nu = new Date(); }
    var morgen = new Date(nu); morgen.setDate(morgen.getDate() + 1);
    if (!isVrij(nu) && nu.getHours() < 16) {
      if (isVrij(morgen)) return { kort: 'Voor 16:00 besteld, bezorgd op de eerstvolgende werkdag', lang: 'Voor 16:00 besteld, bezorgd op de eerstvolgende werkdag' };
      var min = (15 - nu.getHours()) * 60 + (60 - nu.getMinutes());
      var u = Math.floor(min / 60), m = min % 60;
      var rest = u > 0 ? u + ' uur en ' + m + ' min' : m + ' min';
      return { kort: 'Voor 16:00 besteld, morgen in huis', lang: 'Bestel binnen ' + rest + ', morgen in huis' };
    }
    if (!isVrij(nu) && !isVrij(morgen) && morgen.getDay() >= 1 && morgen.getDay() <= 5) {
      return { kort: 'Morgen verzonden, overmorgen in huis', lang: 'Morgen verzonden, overmorgen in huis' };
    }
    return { kort: 'Verzonden op de eerstvolgende werkdag', lang: 'Verzonden op de eerstvolgende werkdag' };
  }
  function zet() {
    var b = bezorg();
    document.querySelectorAll('[data-oph-bezorg]').forEach(function (el) { el.textContent = b.kort; });
    document.querySelectorAll('[data-oph-bezorg-lang]').forEach(function (el) { el.textContent = b.lang; });
  }
  var wacht = null;
  function zetStraks() { clearTimeout(wacht); wacht = setTimeout(zet, 120); }
  function init() {
    zet(); setInterval(zet, 60000);
    initKiezers();
    blokkeerUitverkocht();
    // het thema zet .is-unavailable pas na zijn eigen init; daarom nog een paar keer nalopen
    [400, 1200, 2500].forEach(function (ms) { setTimeout(blokkeerUitverkocht, ms); });
    kleurKaartSwatches();
    opruimKaartLabels();
    syncKaarten();
    stickyKoopknop();
    verbergLeverBijPaneel();
    tabelScroll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tabelScroll).catch(function () {});
    // cart-drawer e.d. worden later in de DOM gezet: bij nieuwe [data-oph-bezorg] opnieuw vullen
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && n.querySelector && n.querySelector('fieldset.option-selector:not([data-op-kiezer])')) initKiezers();
          if (n.nodeType === 1 && n.querySelector && n.querySelector('.op-kaartvar__thumb')) kleurKaartSwatches(n);
          if (n.nodeType === 1 && n.querySelector && n.querySelector('[data-op-kaartvar]')) { opruimKaartLabels(n); syncKaarten(n); }
          if (n.nodeType === 1 && (n.hasAttribute && (n.hasAttribute('data-oph-bezorg') || n.hasAttribute('data-oph-bezorg-lang')) || n.querySelector && n.querySelector('[data-oph-bezorg],[data-oph-bezorg-lang]'))) { zetStraks(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- plakkende koopbalk op mobiel (site-audit 08-09-2026, #44) ----------
     Op mobiel verbergt het thema het label van de koopknop in de plakbalk en laat
     alleen een plusje staan; dat leest niet als "kopen". De CSS-kant (label weer
     tonen) hoort bij op-polish.css; hier staat het stuk dat daar bij hoort: een
     kort label dat naast de productnaam past.
     data-add-to-cart-text moet mee, want variant-picker.js (r.114-122) bouwt de
     knop bij elke variantwissel opnieuw op uit dat attribuut. De bewakingsclausule
     kijkt naar dat attribuut en niet naar de zichtbare tekst: zo houdt een
     pre-orderproduct zijn eigen woord, en klopt het label ook op een product dat
     uitverkocht binnenkomt en pas na een variantwissel koopbaar wordt. */
  function stickyKoopknop() {
    document.querySelectorAll('.sticky-atc-panel .js-atc-button').forEach(function (b) {
      if (!/Toevoegen aan winkelwagen/i.test(b.dataset.addToCartText || '')) return;
      b.dataset.addToCartText = 'In winkelwagen';
      var s = b.querySelector('span[class~="md:block"]');
      if (s && /Toevoegen aan winkelwagen/i.test(s.textContent)) s.textContent = 'In winkelwagen';
    });
  }

  /* ---------- tabellen die horizontaal scrollen (site-audit 08-09-2026, #105) ----------
     .op-page__tablewrap heeft overflow-x: auto. Zodra de tabel breder is dan het
     scherm kan een toetsenbordgebruiker de rechterkolommen niet bereiken, want een
     scrollcontainer zonder tabindex krijgt geen focus (WCAG 2.1.1). We meten het en
     zetten de attributen erop - en halen ze weer weg zodra hij niet meer overloopt,
     zodat er op desktop geen zinloze tabstop blijft staan. */
  function tabelNaam(w) {
    var k = w.previousElementSibling;
    while (k && !/^H[2-4]$/.test(k.tagName)) k = k.previousElementSibling;
    var t = k ? k.textContent.trim().replace(/\s+/g, ' ') : '';
    return t ? t + ' (tabel, horizontaal te scrollen)' : 'Tabel, horizontaal te scrollen';
  }
  function tabelScroll() {
    document.querySelectorAll('.op-page__tablewrap').forEach(function (w) {
      if (w.scrollWidth > w.clientWidth + 2) {
        if (w.getAttribute('tabindex') === '0') return;
        w.setAttribute('tabindex', '0');
        w.setAttribute('role', 'region');
        w.setAttribute('aria-label', tabelNaam(w));
      } else if (w.getAttribute('tabindex') === '0') {
        w.removeAttribute('tabindex');
        w.removeAttribute('role');
        w.removeAttribute('aria-label');
      }
    });
  }
  var tabelWacht = null;
  window.addEventListener('resize', function () { clearTimeout(tabelWacht); tabelWacht = setTimeout(tabelScroll, 150); });
  window.addEventListener('orientationchange', function () { setTimeout(tabelScroll, 250); });

  /* ---------- kleur-swatches + gekozen waarde in de variantkiezer ---------- */
  var KLEUREN = {
    'black':'#1A1A1A','zwart':'#1A1A1A','matte black':'#222222','gloss black':'#111111','titanium black':'#2E2E30',
    'copper black':'#3A2E2A','obsidian black':'#1C1C1E','starry black':'#23242A','mystic black':'#232323',
    'phantom black':'#1C1C1E','black graphite':'#2B2D31','metal black copper':'#3A2F2B','black slate':'#33373B',
    'zwart graphite':'#2B2D31','midnight opus':'#2A2A3A',
    'white':'#F5F5F3','wit':'#F5F5F3','glossy white':'#FAFAFA','misty white':'#EFF0F2','pearl white':'#F3F1EC',
    'soft white':'#F4F2EE','mystic white':'#F4F4F2','phantom white':'#F6F6F4','melodic white':'#F3F3F1',
    'rookwit':'#EDEBE7','lightning white':'#F7F7F5','ligtning white':'#F7F7F5','lunar radiance':'#D8D8E0',
    'navy':'#24324C','nord blue':'#3E5C76','splendid blue':'#3E6C8E','sapphire blue':'#1F4E79','mystic blue':'#3D5A80',
    'ocean blue':'#2E6E8E','chromatic blue':'#3B5BA5','copper blue':'#3E5F6B','blue':'#3B6EA5','blauw':'#3B6EA5',
    'nachtblauw':'#1E2A44','maanblauw':'#5A6E8C','denim':'#5B7590',
    'silver':'#C9CCD1','zilver':'#C9CCD1','radient silver':'#D5D8DC','phantom silver':'#CDD0D4','metal silver':'#C6C9CE',
    'space grey':'#7A7D82','dark grey':'#4A4D52','graphite':'#3F4247','gray':'#8A8D92','grijs':'#8A8D92','grey':'#8A8D92',
    'metallic grey':'#9EA2A8','storm grey':'#6E7378','thunder gray':'#5A5E64','harmonic gray':'#9A9EA4','greige':'#B8B2A8',
    'gold beige':'#D8C6A5','woestijngoud':'#C9A86A','rose gold':'#E3B8A8',
    'cream':'#F1E8D8','beige':'#E3D8C4','light beige':'#EDE4D4','ecru':'#EAE3D2',
    'mint':'#BFE3D0','zen green':'#9FBAA8','arbor green':'#5F7A5F','olive':'#7A7A52','green':'#4E7A5A','soft jade':'#BFD8C8',
    'roze':'#EFB8C8','rose':'#E8AFC0','pink':'#F1B8C4','coral':'#F08A78',
    'lilac':'#C8B8DC','lavender':'#C4B8E0','paars':'#8A5FA8','purple':'#8A5FA8','violet':'#9A7FC0',
    'phantom violet':'#C9B8E8','bora purple':'#A88FD0',
    'geel':'#F0D060','oranje':'#F0904A',
    'cocoa':'#6B4F41','sienna':'#A0563B','caramel':'#C08A50','metal caramel':'#BE8E58','mystic bronze':'#B08A6A',
    'burgundy':'#6E2B3A','royaalrood':'#A02030',
    'diamant 60e editie':'#DCDCE2'
  };
  var KLEUR_TREF = [
    ['black|zwart', '#1A1A1A'], ['white|wit', '#F5F5F3'], ['navy|nacht', '#24324C'], ['blue|blauw|denim', '#3B6EA5'],
    ['silver|zilver|chroom|chrome', '#C9CCD1'], ['gr[ea]y|grijs|graphite|gunmetal', '#6E7378'],
    ['gold|goud|champagne', '#C9A86A'], ['beige|cream|creme|sand|ecru|greige', '#E3D8C4'],
    ['green|groen|jade|mint|olive|sage', '#4E7A5A'], ['pink|roze|rose|blush', '#EFB8C8'], ['coral|koraal', '#F08A78'],
    ['purple|paars|violet|lila|lilac|lavend', '#9A7FC0'], ['yellow|geel', '#F0D060'], ['orange|oranje', '#F0904A'],
    ['red|rood|crimson|bordeaux|burgundy', '#A02030'], ['brown|bruin|cocoa|copper|koper|bronze|brons|caramel|sienna', '#8A5F45']
  ];
  function kleurVoor(naam) {
    var n = (naam || '').toLowerCase().trim();
    if (KLEUREN[n]) return KLEUREN[n];
    for (var i = 0; i < KLEUR_TREF.length; i++) {
      if (new RegExp(KLEUR_TREF[i][0]).test(n)) return KLEUR_TREF[i][1];
    }
    return null;
  }
  var productJsonBelofte = null;
  function haalProductJson() {
    if (productJsonBelofte) return productJsonBelofte;
    var m = window.location.pathname.match(/\/products\/[a-z0-9-]+/);
    if (!m) { productJsonBelofte = Promise.resolve(null); return productJsonBelofte; }
    productJsonBelofte = fetch(m[0] + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return productJsonBelofte;
  }
  function fotoUrl(src, breedte) {
    if (!src) return null;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + breedte;
  }
  function initKiezers() {
    document.querySelectorAll('fieldset.option-selector').forEach(function (fset) {
      if (fset.dataset.opKiezer) return;
      fset.dataset.opKiezer = '1';
      var legend = fset.querySelector('legend');
      var isKleur = legend && /kleur|colou?r/i.test(legend.textContent);
      if (isKleur) fset.classList.add('op-kleur');
      if (isKleur) {
        fset.querySelectorAll('input.opt-btn').forEach(function (inp) {
          var lab = fset.querySelector('label[for="' + inp.id + '"]');
          if (!lab || lab.querySelector('.op-swatch')) return;
          var hex = kleurVoor(inp.value);
          var sw = document.createElement('i');
          sw.className = 'op-swatch';
          sw.setAttribute('aria-hidden', 'true');
          if (hex) sw.style.background = hex;
          else sw.classList.add('op-swatch--multi');
          if (!lab.title) lab.title = inp.value;
          lab.insertBefore(sw, lab.firstChild);
        });
        // upgrade naar productfoto per kleur zodra de productdata er is
        haalProductJson().then(function (prod) {
          if (!prod || !prod.options || !prod.variants) return;
          var legendTekst = (legend.childNodes[0] && legend.childNodes[0].textContent || legend.textContent).trim().toLowerCase();
          var optIndex = -1;
          for (var i = 0; i < prod.options.length; i++) {
            var on = (typeof prod.options[i] === 'string' ? prod.options[i] : prod.options[i].name || '').toLowerCase();
            if (on && legendTekst.indexOf(on) === 0) { optIndex = i; break; }
          }
          if (optIndex < 0) return;
          fset.querySelectorAll('input.opt-btn').forEach(function (inp) {
            var lab = fset.querySelector('label[for="' + inp.id + '"]');
            var sw = lab && lab.querySelector('.op-swatch');
            if (!sw) return;
            var variant = prod.variants.find(function (v) { return v['option' + (optIndex + 1)] === inp.value && v.featured_image && v.featured_image.src; });
            if (!variant) return;
            sw.classList.add('op-swatch--foto');
            lab.classList.add('op-lab--foto');
            sw.style.background = '';
            sw.style.backgroundImage = 'url("' + fotoUrl(variant.featured_image.src, 140) + '")';
          });
        });
      }
      if (isKleur && legend && !legend.querySelector('.op-legend-val')) {
        var val = document.createElement('span');
        val.className = 'op-legend-val';
        legend.appendChild(val);
        var zetVal = function () {
          var checked = fset.querySelector('input.opt-btn:checked');
          val.textContent = checked ? checked.value : '';
        };
        zetVal();
        fset.addEventListener('change', function () { setTimeout(zetVal, 30); });
      }
    });
  }


  /* ---------- variantkeuze op de productkaart (collectie/zoek/upsell) ---------- */
  function toonKaartMelding(bijKnop, tekst) {
    var kaart = bijKnop.closest('product-card, .product-card, .card') || bijKnop.parentElement;
    if (!kaart) return;
    var oud = kaart.querySelector('.op-kaartfout');
    if (oud) oud.remove();
    var p = document.createElement('p');
    p.className = 'op-kaartfout';
    p.setAttribute('role', 'status');
    p.textContent = tekst;
    (bijKnop.parentElement || kaart).appendChild(p);
    setTimeout(function () { if (p.isConnected) p.remove(); }, 6000);
  }

  function kaartVanKnop(el) { return el.closest('product-card, .product-card, .card'); }
  function zetKaartVariant(kaart, knop) {
    var groep = kaart.querySelector('[data-op-kaartvar]');
    if (!groep) return;
    groep.querySelectorAll('.op-kaartvar__knop').forEach(function (b) { b.setAttribute('aria-pressed', b === knop ? 'true' : 'false'); });
    var add = kaart.querySelector('.op-kaartadd');
    if (add) {
      add.dataset.variant = knop.dataset.variant;
      var beschikbaar = knop.dataset.beschikbaar === '1';
      add.disabled = !beschikbaar;
      var tekst = add.querySelector('.quick-add-btn-text');
      if (tekst) tekst.textContent = beschikbaar ? 'In winkelwagen' : 'Uitverkocht';
    }
    // prijs bijwerken: het bedrag staat in .js-value, "Van" is een los voorvoegsel
    // dat weg moet zodra de klant een concrete uitvoering heeft gekozen.
    var prijsBlok = kaart.querySelector('.card__price .price__current');
    if (prijsBlok && knop.dataset.prijs && /[0-9]/.test(knop.dataset.prijs)) {
      var waarde = prijsBlok.querySelector('.js-value');
      if (waarde) waarde.textContent = knop.dataset.prijs;
      var vanaf = prijsBlok.querySelector('.price__from');
      if (vanaf) vanaf.style.display = 'none';
    }
    // kaartfoto meewisselen
    if (knop.dataset.img) {
      var img = kaart.querySelector('.card__media img, .card__main-image');
      if (img) { img.removeAttribute('srcset'); img.src = knop.dataset.img; }
    }
    // voorraadregel: uitverkocht / nalevering / op voorraad.
    // LET OP: v.available is in Shopify ook waar bij nalevering (inventory_policy
    // 'continue' met 0 voorraad). Alleen data-voorraad === '1' is echt voorradig,
    // anders zou de kaart een bezorgbelofte doen die we niet waarmaken.
    var stock = kaart.querySelector('.op-card-meta__stock');
    if (stock) {
      var teKoop = knop.dataset.beschikbaar === '1';
      var opVoorraad = teKoop && knop.dataset.voorraad === '1';
      stock.classList.toggle('is-uit', !opVoorraad);
      stock.innerHTML = '<i></i>' + (!teKoop ? 'Deze uitvoering is uitverkocht' : (opVoorraad ? 'Op voorraad' : 'Nalevering 3-5 werkdagen'));
      var ship = kaart.querySelector('.op-card-meta__ship');
      if (ship) ship.style.display = opVoorraad ? '' : 'none';
    }
  }
  // op kaarten met variantkeuze is ONS voorraadregeltje variant-specifiek;
  // het thema-label (nalevering / x op voorraad) geldt voor het hele product
  // en spreekt dat anders tegen -> daar verbergen we het.
  function opruimKaartLabels(wortel) {
    (wortel || document).querySelectorAll('[data-op-kaartvar]').forEach(function (g) {
      var kaart = g.closest('product-card, .product-card, .card');
      if (!kaart || kaart.dataset.opLabelsOpgeruimd) return;
      kaart.dataset.opLabelsOpgeruimd = '1';
      kaart.querySelectorAll('.product-label--backorder, .product-label--low-stock').forEach(function (lab) {
        var wrap = lab.closest('.product-label-wrapper') || lab;
        wrap.style.display = 'none';
      });
    });
  }
  // de kaart toont bij het laden de PRODUCTfoto en een "vanaf"-prijs, terwijl er al
  // een variant voorgeselecteerd staat. Trek dat gelijk, anders koopt de klant iets
  // anders dan hij ziet.
  function syncKaarten(wortel) {
    (wortel || document).querySelectorAll('[data-op-kaartvar]').forEach(function (g) {
      var kaart = g.closest('product-card, .product-card, .card');
      if (!kaart || kaart.dataset.opGesynct) return;
      kaart.dataset.opGesynct = '1';
      var actief = g.querySelector('.op-kaartvar__knop[aria-pressed="true"]') || g.querySelector('.op-kaartvar__knop');
      if (actief) zetKaartVariant(kaart, actief);
    });
  }
  function kleurKaartSwatches(wortel) {
    (wortel || document).querySelectorAll('.op-kaartvar__thumb').forEach(function (t) {
      if (t.style.backgroundImage) return;
      if (t.dataset.opGekleurd) return;
      t.dataset.opGekleurd = '1';
      var hex = kleurVoor(t.dataset.kleurnaam || '');
      if (hex) t.style.background = hex;
      else t.classList.add('op-swatch--multi');
    });
  }
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('.op-kaartvar__knop');
    if (knop) {
      e.preventDefault(); e.stopPropagation();
      var kaart = kaartVanKnop(knop);
      if (kaart) zetKaartVariant(kaart, knop);
      return;
    }
    var add = e.target.closest && e.target.closest('.op-kaartadd');
    if (add && add.dataset.variant) {
      e.preventDefault(); e.stopPropagation();
      if (add.dataset.opBezig) return;
      add.dataset.opBezig = '1';
      var tekstEl = add.querySelector('.quick-add-btn-text');
      var oudeTekst = tekstEl ? tekstEl.textContent : '';
      if (tekstEl) tekstEl.textContent = 'Bezig...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.variant), quantity: 1 }] })
      }).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (data) {
          if (!r.ok) {
            var e = new Error('toevoegen mislukt');
            e.uitleg = (data && (data.description || data.message)) || '';
            throw e;
          }
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          if (tekstEl) tekstEl.textContent = 'Toegevoegd';
          setTimeout(function () { if (tekstEl) tekstEl.textContent = oudeTekst || 'In winkelwagen'; }, 1600);
        });
      }).catch(function (e) {
        // Shopify vertelt zelf waarom het niet lukte (bv. voorraadlimiet bereikt);
        // die reden is voor de klant nuttiger dan "probeer opnieuw".
        var uitleg = (e && e.uitleg) || '';
        toonKaartMelding(add, uitleg || 'Toevoegen lukte niet. Probeer het opnieuw.');
        if (tekstEl) tekstEl.textContent = oudeTekst || 'In winkelwagen';
      }).then(function () { delete add.dataset.opBezig; });
    }
  }, true);

  /* ---------- echt uitverkochte varianten niet aanklikbaar maken ----------
     Het thema markeert combinaties die niet te bestellen zijn met .is-unavailable
     op de radio-input, en werkt dat bij als je een andere optie kiest. We volgen
     die markering en zetten de input op disabled, zodat je er niet per ongeluk
     op klikt. Nalevering krijgt die klasse NIET en blijft dus gewoon kiesbaar. */
  function blokkeerUitverkocht() {
    document.querySelectorAll('variant-picker input.opt-btn').forEach(function (inp) {
      var uit = inp.classList.contains('is-unavailable');
      // een variant die al gekozen is nooit disablen: dan kan het thema niet meer terug
      if (uit && !inp.checked) {
        if (!inp.disabled) { inp.disabled = true; inp.setAttribute('aria-disabled', 'true'); }
      } else if (inp.disabled) {
        inp.disabled = false;
        inp.removeAttribute('aria-disabled');
      }
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('js-option')) setTimeout(blokkeerUitverkocht, 80);
  });

  // voorraadregel ("Past bij jouw set") meebewegen met de gekozen variant.
  // Het thema levert per variant al rw-variant-stock: s = geen voorraad, o = te koop.
  // Die gebruiken we hier, zodat de levertijd op é é n plek staat en de losse gele
  // #rw-delivery-notice weg kan (die stond er anders dubbel).
  var voorraadTabel = null;
  function leesVoorraadTabel() {
    if (voorraadTabel !== null) return voorraadTabel;
    var sc = document.querySelector('script.rw-variant-stock');
    if (!sc) { voorraadTabel = false; return voorraadTabel; }
    try {
      var arr = JSON.parse(sc.textContent);
      var map = {};
      arr.forEach(function (x) { map[x.k] = x; });
      voorraadTabel = { lijst: arr, opSleutel: map };
    } catch (e) { voorraadTabel = false; }
    return voorraadTabel;
  }
  function huidigeVoorraad() {
    var tab = leesVoorraadTabel();
    if (!tab) return null;
    var ins = document.querySelectorAll('variant-picker input.js-option:checked');
    if (!ins.length) return tab.lijst.length === 1 ? tab.lijst[0] : null;
    var vals = [];
    ins.forEach(function (i) { vals.push(i.value); });
    return tab.opSleutel[vals.join('||')] || null;
  }
  /* Site-audit 08-09-2026 (#77): staat het paneel "Niet meer leverbaar" op de pagina
     (dat verschijnt zodra product.available false is), dan zou deze regel er een
     tweede, tegenstrijdige boodschap vlak boven zetten ("Tijdelijk uitverkocht -
     kies een andere uitvoering", terwijl er geen andere uitvoering is). Eén stem
     per pagina: het paneel wint, de regel gaat weg. */
  function verbergLeverBijPaneel() {
    if (!document.querySelector('.rw-soldout-panel')) return false;
    var lever = document.querySelector('.op-pastbij .op-lever, .op-lever');
    if (lever) lever.hidden = true;
    return true;
  }
  function zetLever() {
    var lever = document.querySelector('.op-pastbij .op-lever, .op-lever');
    if (!lever) return;
    if (verbergLeverBijPaneel()) return;
    var v = huidigeVoorraad();
    lever.classList.remove('op-lever--uit', 'op-lever--wacht');
    if (v && !v.o) {
      lever.classList.add('op-lever--uit');
      lever.innerHTML = '<i></i><span>Tijdelijk uitverkocht<small>Kies een andere uitvoering of mail ons voor de verwachte datum</small></span>';
      return;
    }
    if (v && v.s) {
      // te koop, maar niet op voorraad -> eerlijke levertijd in plaats van een bezorgbelofte
      lever.classList.add('op-lever--wacht');
      lever.innerHTML = '<i aria-hidden="true">&#9888;</i><span>Let op: levertijd 3&ndash;5 werkdagen<small>Dit onderdeel ligt niet op voorraad en wordt voor je besteld</small></span>';
      return;
    }
    lever.innerHTML = '<i></i><span>Op voorraad<small data-oph-bezorg-lang>Voor 16:00 besteld, morgen in huis</small></span>';
    zet();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('js-option')) setTimeout(zetLever, 60);
  });
  if (document.querySelector('script.rw-variant-stock')) setTimeout(zetLever, 80);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* --------------------------------------------------------------------------
   Zichtbare schermhoogte voor de winkelwagenlade.

   De lade stond in main.css op height:100%. Voor een position:fixed element is
   dat de LAYOUT-viewport, en die is op iOS Safari hoger dan wat je werkelijk
   ziet: de adresbalk onderin en de home-indicator liggen eroverheen. De onderste
   84 pixels van de lade - precies waar Afrekenen staat - vielen daardoor op een
   echte iPhone achter die balken. In een testvenster zie je dat nooit, want daar
   is er geen browserbalk.

   window.visualViewport geeft wel de hoogte die de klant echt ziet, en verandert
   mee als de balken in- of uitschuiven. Die zetten we in --op-vh; de CSS leest
   hem. Zonder JavaScript valt de lade terug op 100dvh, en zonder dvh-steun op
   de oude 100% - dus het wordt nooit slechter dan het was.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__opVhBoot) return;
  window.__opVhBoot = true;

  var wortel = document.documentElement;

  function zet() {
    /* Terwijl iemand in het notitie- of kortingsveld typt schuift het toetsenbord
       op en krimpt visualViewport. De lade zou dan meekrimpen en de inhoud onder
       de vingers wegspringen. Tijdens het typen dus niet aanpassen. */
    var a = document.activeElement;
    if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable)) return;
    var vv = window.visualViewport;
    var h = vv && vv.height ? vv.height : window.innerHeight;
    wortel.style.setProperty('--op-vh', Math.round(h) + 'px');
  }

  zet();
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', zet);
    window.visualViewport.addEventListener('scroll', zet);
  }
  window.addEventListener('resize', zet);
  window.addEventListener('orientationchange', function () { setTimeout(zet, 250); });
  document.addEventListener('focusout', function () { setTimeout(zet, 150); });
})();

/* Site-audit 08-09-2026: "Zoek je een andere accessoire?" (featured collection op de productpagina)
   toonde het product zelf tussen de alternatieven. De sectie haalt nu 8 producten op; het eigen
   product gaat weg en van de rest blijven de eerste 4 staan. */
(function () {
  'use strict';
  function opruimen() {
    if (!/^\/products\//.test(location.pathname)) return;
    var zelf = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.cc-featured-collection').forEach(function (sec) {
      if (sec.dataset.opOntdubbeld) return;
      var kaarten = Array.prototype.slice.call(sec.querySelectorAll('product-card, .product-card'));
      if (kaarten.length < 5) return; /* sectie haalt er 8 op */
      var eigen = kaarten.filter(function (k) {
        var a = k.querySelector('a[href*="/products/"]');
        if (!a) return false;
        var pad = a.getAttribute('href').split('?')[0].split('#')[0].replace(/\/$/, '');
        return pad === zelf || pad.indexOf(zelf + '/') === 0;
      });
      var over = kaarten.filter(function (k) { return eigen.indexOf(k) < 0; });
      var weg = eigen.concat(over.slice(4));
      weg.forEach(function (k) { var li = k.closest('li') || k; li.parentNode && li.parentNode.removeChild(li); });
      sec.dataset.opOntdubbeld = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', opruimen); else opruimen();
  [300, 1200].forEach(function (ms) { setTimeout(opruimen, ms); });
})();

/* Ontwerpronde 08-09-2026: de SEO-tekst onder een collectie begint met een H2 die gelijk is aan de
   paginatitel ("AirPods Pro 2" twee keer boven elkaar). Die kop blijft in de HTML, maar wordt verborgen. */
(function () {
  'use strict';
  function dubbeleKop() {
    if (!/^\/collections\//.test(location.pathname)) return;
    var h1 = document.querySelector('h1');
    if (!h1) return;
    var t = h1.textContent.trim().toLowerCase();
    document.querySelectorAll('[class^="ai-page-description__container"] h2, .op-colhulp-section ~ .shopify-section h2').forEach(function (h2) {
      if (h2.textContent.trim().toLowerCase() !== t) return;
      h2.classList.add('op-dup-h2');
      /* het losse accentstreepje direct onder de kop gaat mee */
      var nx = h2.nextElementSibling;
      if (nx && !nx.textContent.trim() && nx.getBoundingClientRect().height < 8) nx.classList.add('op-dup-h2');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dubbeleKop); else dubbeleKop();
})();

/* ==========================================================================
   Site-audit 08-09-2026 — losse blokken (werkgroep polish-js).
   Elk blok staat op zichzelf: eigen 'use strict', eigen boot-guard en eigen start.
   ========================================================================== */

/* De stijlregels die bij de twee blokken hieronder horen.
   Ze staan hier en niet in op-polish.css omdat dat bestand in deze ronde door een
   andere werkgroep wordt bijgewerkt; twee schrijvers op één bestand raken elkaars
   werk kwijt. De regels zijn puur additief en gebruiken de OnePod-tokens met een
   letterlijke terugval, want --op-acc en --op-tint zijn in op-onepod.css op .op-page
   gezet en niet op :root - op de zoekpagina bestaan ze dus niet. */
(function () {
  'use strict';
  if (document.getElementById('op-polish-js-css')) return;
  var regels = [
    /* #11 - scrollslot achter de mobiele menulade. Zelfde aanpak als het thema zelf
       voor zijn lades gebruikt (main.css: html:has(.drawer[open]) { overflow: hidden }),
       via een klasse zodat een bestaande inline-waarde op <html> niet sneuvelt. */
    'html.op-menu-open { overflow: hidden; }',
    /* #105 - zichtbare focus op een tabel die horizontaal scrolt. Alleen bij
       toetsenbordfocus, zodat een muisklik in de tabel geen kader oplevert. */
    '.op-page__tablewrap:focus { outline: none; }',
    '.op-page__tablewrap:focus-visible { outline: 2px solid var(--op-acc, #146A83); outline-offset: 3px; border-radius: 6px; }',
    /* #81 - hulpstrook boven de zoekresultaten */
    '.op-zoekhulp { background: var(--op-tint, #E9F1F4); border-radius: 14px; padding: 14px 20px; margin: 0 0 22px; }',
    '.op-zoekhulp__kop { margin: 0 0 8px; font-family: var(--op-body, "Instrument Sans", system-ui, sans-serif); font-weight: 700; font-size: 12px; line-height: 1.2; letter-spacing: .06em; text-transform: uppercase; color: var(--op-acc-dk, #0F5266); }',
    '.op-zoekhulp ul { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 8px 22px; }',
    '.op-zoekhulp li { margin: 0; }',
    '.op-zoekhulp a { font-family: var(--op-body, "Instrument Sans", system-ui, sans-serif); font-size: 14px; line-height: 1.35; color: var(--op-acc-dk, #0F5266); text-decoration: underline; text-underline-offset: 2px; text-decoration-thickness: 1px; }'
  ].join('\n');
  var st = document.createElement('style');
  st.id = 'op-polish-js-css';
  st.textContent = regels;
  (document.head || document.documentElement).appendChild(st);
})();

/* --------------------------------------------------------------------------
   Site-audit 08-09-2026 (#11): de schermvullende mobiele menulade gedroeg zich
   niet als een modal.

   1. De focus liep de lade uit. trapFocus van het thema (main.js r374) bepaalt het
      laatste focusbare element met offsetParent, en dat is een item in een GESLOTEN
      submenu dat buiten beeld staat (x = 408 op een scherm van 390). De wrap kwam
      daardoor nooit; na elf tabs stond je op het logo, daarna in de onzichtbare
      pagina erachter.
   2. Escape deed niets. Het thema hangt zijn Escape-afhandeling op keyup op
      .main-nav en doet daar close(this.nav.querySelector('details.is-open')).
      Staat er geen submenu open, dan is dat null en loopt close() stuk.
   3. De pagina erachter was niet inert en scrolde gewoon door.

   Deze drie zetten we hier recht, zonder main.js aan te raken. De lade wordt
   geopend en gesloten via de eigen knop van het thema, dus alle bestaande logica
   (overlay, animatie, focus terug) blijft van het thema zelf.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__opMenuBoot) return;
  window.__opMenuBoot = true;

  var FOCUSBAAR = 'summary, a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function mobielMenu() {
    var mm = document.querySelector('main-menu');
    if (!mm) return;
    var disc = mm.querySelector('.main-menu__disclosure');
    var toggle = mm.querySelector('.main-menu__toggle');
    if (!disc || !toggle) return;

    /* lg = (min-width: 1024px), gelijk aan theme.mediaQueries.lg en aan de
       lg:hidden op de hamburger. */
    function mobiel() { return !window.matchMedia('(min-width: 1024px)').matches; }

    /* Het thema haalt de klasse is-open er meteen af en zet open pas op false als
       de sluitanimatie klaar is. Daarom kijken we naar allebei: open + niet aan het
       sluiten. Zo komt het slot er direct af als de klant sluit. */
    function ladeOpen() {
      return mobiel() && disc.open && !disc.classList.contains('is-closing');
    }

    /* Echt zichtbaar in de lade. De rect-breedte alleen is niet genoeg: items in een
       gesloten submenu zijn met transform naar rechts geschoven en houden hun maten.
       Daarom ook: valt hij binnen het scherm, en is hij niet weggefadet? De hamburger
       zelf hoort niet in de ronde te zitten - die ligt achter de lade. */
    function zichtbaar(el) {
      if (el === toggle) return false;
      var r = el.getBoundingClientRect();
      if (r.width <= 0 || r.height <= 0) return false;
      if (r.left >= window.innerWidth || r.right <= 0) return false;
      var cs = window.getComputedStyle(el);
      return cs.visibility !== 'hidden' && cs.opacity !== '0';
    }
    function focusbaar() {
      var uit = [];
      var alles = disc.querySelectorAll(FOCUSBAAR);
      for (var i = 0; i < alles.length; i++) if (zichtbaar(alles[i])) uit.push(alles[i]);
      return uit;
    }

    /* Achtergrond stilzetten en uit de tabvolgorde halen. Staat los van de
       MutationObserver, want bij het passeren van 1024 px verandert het
       open-attribuut niet en zou de site anders dood blijven staan. */
    function pasToe() {
      try {
        var aan = ladeOpen();
        var buiten = document.querySelectorAll('main, footer, .header__grid > *');
        for (var i = 0; i < buiten.length; i++) {
          var el = buiten[i];
          if (el === mm || el.contains(mm)) continue;
          el.toggleAttribute('inert', aan);
        }
        document.documentElement.classList.toggle('op-menu-open', aan);
      } catch (e) { /* een polish-script mag de pagina nooit kunnen blokkeren */ }
    }

    disc.addEventListener('keydown', function (e) {
      try {
        if (!ladeOpen()) return;

        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          e.stopPropagation();
          /* Gelaagd: eerst het diepste open submenu, pas daarna de hele lade.
             Nooit twee niveaus in één toetsaanslag. */
          var open = disc.querySelectorAll('.main-nav details.is-open');
          var sub = open.length ? open[open.length - 1] : null;
          var som = sub && sub.querySelector(':scope > summary');
          if (sub && som) {
            som.click();                 /* eigen weg van het thema: sluit + overlay uit */
            if (zichtbaar(som)) som.focus();
            else if (sub.previousElementSibling && sub.previousElementSibling.focus) sub.previousElementSibling.focus();
            return;
          }
          /* Focus meteen naar de hamburger: die ligt buiten .main-nav, dus de
             keyup-afhandeling van het thema (die op null stukloopt) gaat niet af. */
          toggle.click();
          toggle.focus();
          return;
        }

        if (e.key !== 'Tab') return;
        var els = focusbaar();
        if (els.length < 2) return;
        var eerste = els[0], laatste = els[els.length - 1];
        if (e.shiftKey && document.activeElement === eerste) {
          e.preventDefault();
          e.stopPropagation();          /* anders springt trapFocus van het thema er alsnog overheen */
          laatste.focus();
        } else if (!e.shiftKey && document.activeElement === laatste) {
          e.preventDefault();
          e.stopPropagation();
          eerste.focus();
        }
      } catch (err) { /* stil: nooit de toetsafhandeling blokkeren */ }
    });

    try {
      new MutationObserver(pasToe).observe(disc, { attributes: true, attributeFilter: ['open', 'class'] });
    } catch (e) { /* geen observer? dan blijft alleen de breekpunt-afhandeling over */ }
    window.addEventListener('on:breakpoint-change', pasToe);
    pasToe();
  }

  function start() { try { mobielMenu(); } catch (e) { /* stil */ } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* --------------------------------------------------------------------------
   Site-audit 08-09-2026 (#81): op de zoekresultatenpagina verdrinken de
   koppelgidsen en servicepagina's tussen de producten. Shopify sorteert op
   relevantie over alle typen heen en productbeschrijvingen bevatten dezelfde
   woorden, dus "koppelen" gaf 89 resultaten met op pagina 1 geen enkele gids.

   We halen de pagina's en artikelen apart op met /search/suggest.json en zetten
   ze als één regel links boven het raster. Staat er niets bij dat nog niet in het
   raster staat, dan verschijnt de strook niet.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__opZoekhulpBoot) return;
  window.__opZoekhulpBoot = true;

  function padVan(href) {
    if (!href) return '';
    var p = String(href).split('?')[0].split('#')[0];
    while (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p;
  }

  function zoekhulp() {
    if (!document.body.classList.contains('template-search')) return;
    if (document.querySelector('.op-zoekhulp')) return;
    var grid = document.getElementById('filter-results');
    if (!grid) return;
    var wrap = grid.closest('.main-products-grid');
    if (!wrap || !wrap.parentNode) return;
    var q = new URLSearchParams(window.location.search).get('q');
    if (!q || !q.trim()) return;
    document.body.setAttribute('data-op-zoekhulp', 'bezig');

    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=page,article&resources[limit]=4&resources[limit_scope]=each';

    fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var res = j && j.resources && j.resources.results;
      if (!res) return;

      /* wat al in het raster staat hoeft er niet nog een keer boven */
      var alHier = {};
      var links = grid.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) alHier[padVan(links[i].getAttribute('href'))] = 1;

      var kandidaten = (res.pages || []).concat(res.articles || []);   /* pagina's eerst */
      var items = [];
      for (var k = 0; k < kandidaten.length && items.length < 4; k++) {
        var p = kandidaten[k];
        if (!p || !p.url || String(p.url).charAt(0) !== '/') continue;
        var titel = String(p.title || '').replace(/<[^>]*>/g, '').trim();
        if (!titel || /^lees verder$/i.test(titel)) continue;
        if (alHier[padVan(p.url)]) continue;
        items.push({ url: p.url, titel: titel });
      }
      if (!items.length) return;
      if (document.querySelector('.op-zoekhulp')) return;

      /* alles met textContent opbouwen: de zoekterm komt van de klant en mag nooit
         als opmaak worden gelezen */
      var sec = document.createElement('section');
      sec.className = 'op-zoekhulp';
      var kop = document.createElement('p');
      kop.className = 'op-zoekhulp__kop';
      kop.textContent = 'Hulp bij ‘' + q.trim() + '’';
      var ul = document.createElement('ul');
      items.forEach(function (it) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.setAttribute('href', it.url);
        a.textContent = it.titel;
        li.appendChild(a);
        ul.appendChild(li);
      });
      sec.appendChild(kop);
      sec.appendChild(ul);
      wrap.parentNode.insertBefore(sec, wrap);
      document.body.setAttribute('data-op-zoekhulp', 'klaar');
    }).catch(function () { /* geen hulpstrook is geen probleem */ });
  }

  function start() { try { zoekhulp(); } catch (e) { /* stil */ } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
